export const availableCalculators = {
    "home-affordability-calc": "home-affordability",
    "mortgage-calc": "mortgage",
    "rent-vs-buy-calc": "rent-vs-buy",
    "refinance-calc": "refinance",
    "home-equity-calc": "home-equity",
}

export const calculatorEnvs = {
    "production": {
        "domain": "https://tools.quickenloans.com",
    },
    "local": {
        "domain": "https://dev.tools.quickenloans.com",
    },
    "development": {
        "domain": "https://dev.tools.quickenloans.com",
    },
    "qa": {
        "domain": "https://qa.tools.quickenloans.com",
    },
    "localhost": {
        "domain": "https://dev.tools.quickenloans.com",
    }
};
